import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { observer } from "mobx-react-lite";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import { useCanvasSearchTermParam } from "src/flowGraph/useCanvasSearchTermParam";
import { useFlowGraphSearchWindow } from "src/flowGraph/useFlowGraphSearchWindow";

type Props = {
  parameterName: string;
  disabled: boolean;
};

export const HighlightParametersToggleButton: React.FC<Props> = observer(
  ({ parameterName, disabled }) => {
    const { openSearchWindow, closeSearchWindow } = useFlowGraphSearchWindow();
    const { searchTerm } = useCanvasSearchTermParam();
    const searchParamQuery = `params.${parameterName}`;
    const isHighlighted = searchTerm === searchParamQuery;

    const toggleHighlighting = () => {
      if (isHighlighted) {
        closeSearchWindow();
      } else {
        openSearchWindow({
          searchTerm: searchParamQuery,
          keepLeftPaneOpen: true,
        });
      }
    };

    return (
      <Tooltip
        body="Search the canvas to find where this parameter is used."
        disabled={disabled}
        asChild
      >
        <button
          className={twJoin(
            "font-inter-normal-12px",
            disabled && "cursor-not-allowed",
          )}
          data-loc={`highlight-${parameterName}-toggle-button`}
          disabled={disabled}
          onClick={toggleHighlighting}
        >
          <div className="flex items-center">
            <Icon
              variant={
                disabled ? "disabled" : isHighlighted ? "active" : "default"
              }
              icon={faSearch}
              size="xs"
            />
          </div>
        </button>
      </Tooltip>
    );
  },
);
